import { useReduxState } from 'hooks';
import {
  HomePageSettingsModulesModuleFooter,
  HomePageSettingsModulesModuleUpdateSettings,
  HomePageSettingsTilesCourses
} from '.';

import type { ModuleInSettings } from './HomePageSettingsModules';

interface Props {
  module: ModuleInSettings;
  updateModule: (module: ModuleInSettings) => void;
}

const HomePageSettingsModulesModuleCoursesAvailable = ({
  module,
  updateModule
}: Props) => {
  const { messages } = useReduxState();

  const url =
    `/admin/courses?courseType=available&page=1&sortBy=alphabetical` +
    `&limit=${module.limit}`;

  return (
    <div>
      <HomePageSettingsTilesCourses module={module} url={url} />

      <HomePageSettingsModulesModuleFooter
        items={[
          {
            label: messages.homePageSettingsModulesNumberOfCourses,
            value: `${messages.homePageSettingsModulesLimitMax} ${module.limit}`
          }
        ]}
      >
        <HomePageSettingsModulesModuleUpdateSettings
          module={module}
          onUpdate={updateModule}
          productType="course"
        />
      </HomePageSettingsModulesModuleFooter>
    </div>
  );
};

export default HomePageSettingsModulesModuleCoursesAvailable;
